import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// components
import FormSelectDialogCaret from "core/FormSelectDialog/variations/FormSelectDialogCaret";
import { DialogStyled } from "core/FormSelectDialog/components/Dialog.js";

// styles
import { SortStyled } from "./styles.js";
const FormSelectDialogCaretStyled = styled(FormSelectDialogCaret)`
    ${DialogStyled} {
        ul {
            z-index: 100;
        }
    }
`;

const Sort = ({ options, selectedOption, onSelect }) => {
    return (
        <SortStyled>
            <FormSelectDialogCaretStyled
                id={`form-select-sort`}
                label="Sort"
                controlLabelOverride="Sort"
                options={options}
                selectedOption={selectedOption}
                setSelectedOption={onSelect}
                dialogAlignment="right"
            />
        </SortStyled>
    );
};

export default Sort;

// prop-types
Sort.propTypes = {
    options: PropTypes.array,
    selectedOption: PropTypes.object,
    onSelect: PropTypes.func
};
